module.exports = __webpack_public_path__ + "static/candidate-tools-518c2bf36120afd65c80c4551879ff5d.png";